module.exports = __webpack_public_path__ + "static/img/glove_gitane.e9fa5cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colors/women/glove_gitane.png
// module id = FZKL
// module chunks = 0